<div class="modal-header">
    <p class="modal-title pull-left" [innerHTML]="title"></p>
    <button *ngIf="!timeout" type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="input" style="position:relative">
      <input #text [(ngModel)]="inputText" type="text" class="form-control" [placeholder]="inputPlaceholder" (change)="onChange()" (keyup.enter)="respond('OK')">
      <!-- <span *ngIf="speechApi && enableSpeech" class="input-group-addon search-addon"> -->
      <mat-icon id="microfon-ic" title='Search by voice' (click)="activateSpeech()">keyboard_voice</mat-icon>
      <div *ngIf="invalid" class="invalid-feedback show">
        <div>Type "{{validateInput}}" to confirm deletion of selected component</div>
      </div>
    </div>
    <div [innerHTML]="message" class="message"></div>
    <div *ngIf="timer" class="timeout">
      {{timer}}
      <span class="timeout-desc">secs</span>
    </div>
  </div>
  <div class="modal-footer">
    <ng-container *ngIf="options.length">
      <button *ngFor="let option of options" type="button" class="btn btn-default btn-respond {{option}} {{positiveButtonColor}}" [class.LIGHT]="option.split(',').length > 1"
      (click)="respond(option.split(',')[0])">{{option.split(',')[0]}}</button>
    </ng-container>
  </div>
  